import gql from 'graphql-tag';

export const GET_PFES_ENS = gql`
  query getEnseignantById($id: Int) {
    getEnseignantById(id: $id) {
      pfes {
        id
        titre
        entreprise
        code_projet
      }
    }
  }
`;

export const GET_PFE_YEARS = gql`
  query getAllAnnesPfe {
    getAllAnnesPfe
  }
`;

export const GET_ALL_PFES = gql`
  query getPfes($annee: Int) {
    getPfes(annee: $annee) {
      id
      code_projet
      titre
      entreprise
      cin_encadreur
      coefficient
      annee
      updated_date
      enseignant {
        nom
        prenom
      }
    }
  }
`;

export const IMPORT_PFES = gql`
  mutation importerPfes($file: String!, $dep_id: ID!) {
    importerPfes(file: $file, dep_id: $dep_id) {
      success
      message
    }
  }
`;

export const DELETE_PFE = gql`
  mutation deletePfe($id: ID!) {
    deletePfe(id: $id)
  }
`;

export const UPDATE_PFE = gql`
  mutation updatePfe($id: ID!, $code_projet: String!) {
    updatePfe(id: $id, code_projet: $code_projet) {
      success
      message
    }
  }
`;
export const DUPLIQUER_PFE = gql`
  mutation dupliquerPfe($idEns: ID!, $idPfe: ID!) {
    dupliquerPfe(idEns: $idEns, idPfe: $idPfe) {
      success
      message
    }
  }
`;

export const GET_TALON_PFE = gql`
  query getTalonPfe($year: Int!) {
    getTalonPfe(year: $year) {
      id
      nom_ar
      prenom_ar
      cin
      indentifiant_unique
      mail
      telephone
      grade_ar
      etab_ar
      pfe_talon_students {
        niveau
        etudiant_1
        etudiant_2
        titre_courrier
        etab
      }
    }
  }
`;
